// extracted by mini-css-extract-plugin
module.exports = {"crowdfunding":"CrowdFunding_crowdfunding__HH2iD"};